// persister.ts
import {
  PersistedClient,
  Persister,
} from "@tanstack/react-query-persist-client";

export const localStoragePersister: Persister = {
  persistClient: async (client: PersistedClient) => {
    localStorage.setItem("REACT_QUERY_OFFLINE_CACHE", JSON.stringify(client));
  },
  restoreClient: async (): Promise<PersistedClient | undefined> => {
    const cache = localStorage.getItem("REACT_QUERY_OFFLINE_CACHE");
    if (!cache) return undefined;
    return JSON.parse(cache);
  },
  removeClient: async () => {
    localStorage.removeItem("REACT_QUERY_OFFLINE_CACHE");
  },
};
